// React
import React from 'react';
// Contexts
import { AuthContext } from 'context/auth/AuthProvider';


export default function useAuth() {
    return React.useContext(AuthContext);
}